import Fleet from "@/models/Fleet";

export class FleetTransformer {
    transform (data) {
        return new Fleet(
            data.id,
            data.name,
            data.totalDevices,
            data.unallocatedDevices,
            data.allocatedDevices,
        )
    }
}
